module.exports = __webpack_public_path__ + "static/media/calendar.75a59bd0.svg";